const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveRoles'
const GetAllRoles = "UserManagement/GetAllRoles"

const GetallDepartments = "Common/GetallDepartments"
const GetDocumentCategoryByDeptId = "Common/GetDocumentCategoryByDeptId"
const GetAllDocumentCategories = "Common/GetAllDocumentCategories"
const GetAllDocumentTypes = "Common/GetAllDocumentTypes"
const GetAllFiles = "File/GetAllFiles"
export const ApiUrls = {
  GetUsers,
  GetUserRoles,
  SaveUserRoles,
  GetAllRoles,

  GetallDepartments,
  GetDocumentCategoryByDeptId,
  GetAllDocumentCategories,
  GetAllDocumentTypes,
  GetAllFiles
}